<script lang="ts" setup>
import { useQuery } from '@pinia/colada'

const props = defineProps<{
  listed?: boolean
}>()

// The home route has no :projectId param, so source it from auth rather than useProjectId().
const auth = useAuth()
const projectId = computed(() => auth.project?.id)

const { data: stats, isLoading: loading } = useQuery({
  ...buildApiQuery('/projects/{projectId}/dashboard-stats', {
    params: () => ({
      path: {
        projectId: projectId.value!,
      },
    }),
  }),
  enabled: () => Boolean(projectId.value),
  refetchOnWindowFocus: false,
})

const listedStats = computed(() => (stats.value?.isTokenListed ? stats.value : undefined))
const preTgeStats = computed(() => (stats.value && !stats.value.isTokenListed ? stats.value : undefined))
const showListed = computed(() => (stats.value ? stats.value.isTokenListed : props.listed))
</script>

<template>
  <div class="grid grid-cols-1 gap-4 @3xl:grid-cols-3">
    <template v-if="showListed">
      <StatTokenPrice
        :loading="loading"
        :project-id="projectId!"
        :project-ticker="listedStats?.projectTicker"
        :token-prices="listedStats?.tokenPrices"
        activity-path="/analyze-trade-activity"
      />
      <StatTokenVolume
        :loading="loading"
        :project-ticker="listedStats?.projectTicker"
        :volume24h="listedStats?.volume24h ?? null"
        :depth2-pct="listedStats?.depth2Pct ?? null"
      />
      <StatMmRfqStatus
        :loading="loading"
        :project-id="projectId!"
        :rfq-status="listedStats?.mmRfqStatus"
        :received-quotes="listedStats?.mmReceivedQuotes"
        :engagements="listedStats?.mmEngagements"
        :last-reported-at="listedStats?.mmRfqLastReportedAt"
      />
    </template>
    <template v-else>
      <StatTgeDate
        :loading="loading"
        :project-id="projectId!"
        :tge-date="preTgeStats?.tgeDate"
        :is-research="preTgeStats?.isResearch"
      />
      <StatPublicPage
        :loading="loading"
        :project-id="projectId!"
        :project-ticker="preTgeStats?.projectTicker"
        :is-public-page-published="preTgeStats?.isPublicPagePublished"
      />
      <StatMmRfqStatus
        :loading="loading"
        :project-id="projectId!"
        :rfq-status="preTgeStats?.mmRfqStatus"
        :received-quotes="preTgeStats?.mmReceivedQuotes"
        :engagements="preTgeStats?.mmEngagements"
        :last-reported-at="preTgeStats?.mmRfqLastReportedAt"
      />
    </template>
  </div>
</template>
